import { ZEvent } from "../../../shared/utils/z-event";
import type { IMessageDTO } from "../../../shared/dtos";

export enum MessageEventTypes {
	ReceiveNewMessage = "message.receive-new-message",
}

export class ReceiveNewMessageEvent extends ZEvent {
	public message: IMessageDTO;
	constructor(message: IMessageDTO) {
		super(MessageEventTypes.ReceiveNewMessage);
		this.message = message;
	}
}

export type MessageEventMap = {
	[MessageEventTypes.ReceiveNewMessage]: ReceiveNewMessageEvent;
};